import type { DataIdentifier, DocumentKind } from '@onefootprint/request-types';

const BASE_RELEVANT_KEYS: DataIdentifier[] = [
  'id.first_name',
  'id.middle_name',
  'id.last_name',
  'id.dob',
  'id.address_line1',
  'id.address_line2',
  'id.city',
  'id.state',
  'id.zip',
  'id.country',
];

const SSN_KEYS: DataIdentifier[] = ['id.ssn4', 'id.ssn9'];

const getRelevantNonDocumentKeys = (documentKind: DocumentKind): DataIdentifier[] => {
  return documentKind === 'ssn_card' ? [...BASE_RELEVANT_KEYS, ...SSN_KEYS] : BASE_RELEVANT_KEYS;
};

export default getRelevantNonDocumentKeys;
